import * as React from "react";
import { useEffect } from "react";
import Header from "@/components/organisms/NewHeader";
import Footer from "@/components/organisms/Footer";
import Row from "@/components/atoms/Row";
import Col from "@/components/atoms/Col";
import FormProvider from "@/components/organisms/FormProvider";
import PropertyBlock from "@/components/organisms/PropertyBlock";
import PropertyDetailBlock from "@/components/organisms/PropertyDetailBlock";
import SaleReason from "@/components/organisms/SaleResonBlock";
import CustomerBlock from "@/components/organisms/CustomerBlock";
import ValuationConfirm from "@/components/organisms/ValuationConfirm";
import TypeBlock from "@/components/organisms/TypeSelector";
import StepProgressBar from "@/components/atoms/StepProgressBar";
import { useTheme } from "@/hooks/useTheme";
import QueryKey from "@/constants/QueryKey";
import { useQueryParams } from "@/utils/hooks";
import { setTrafficSourceIdForSessionStorage } from "@/utils/trafficSource";
import MediaQueryContext, { initMediaQueryStore } from "@/contexts/MediaQuery";
import styled from "@emotion/styled";

const DisplayNone = styled.div`
  visibility: hidden;
`;

const IndexPageWrapper = styled.div`
  font-family: Noto Sans JP;
  background-color: #f7f7f7;
  overflow-x: hidden; 
`;

const desktop = {
  part1: 1.75,
  part2: 8.25,
  part3: 1.75,
};

const desktop2 = {
  part1: 1.75,
  part2: 8.5,
  part3: 1,
  part4: 0.75,
};
const mobile = {
  part1: 0,
  part2: 12,
  part3: 0,
};

const mobile2 = {
  part1: 0,
  part2: 12,
  part3: 0,
  part4: 0,
};

const IndexPage = () => {
  const { COLOR_THEME } = useTheme();
  const queryParameters = useQueryParams();
  const trafficSourceId = queryParameters.get(QueryKey.TRAFFIC_SOURCE);
  const { current: range } = React.useContext(MediaQueryContext) || initMediaQueryStore("md");
  const rl = range === "sm" ? mobile : desktop;
  const rl2 = range === "sm" ? mobile2 : desktop2;
  const [current, setCurrent] = React.useState({
    step1: false,
    step2: false,
    step3: false,
    step4: false,
  });

  useEffect(() => {
    setTrafficSourceIdForSessionStorage(trafficSourceId);
  }, []);

  const handleNextAction = React.useCallback(
    (key: "step1" | "step2" | "step3" | "step4") => () => {
      setCurrent(() => ({ ...current, [key]: true }));
    },
    [current]
  );
 
  return (
    <IndexPageWrapper>
      <Header isDescriptionEnabled={true} />
      <FormProvider>
        <Row>
          <Col size={rl.part1}>
            <DisplayNone>*</DisplayNone>
          </Col>
          <Col size={rl.part2}>
            <TypeBlock onNext={handleNextAction("step1")} />
          </Col>
          <Col size={rl.part3}>
            <DisplayNone>*</DisplayNone>
          </Col>
        </Row>
        <Row
          style={{
            paddingTop: "3px",
          }}
        >
          <Col size={rl2.part1}>
            <DisplayNone>*</DisplayNone>
          </Col>
          <Col size={rl2.part2}>
            {current.step1 && <PropertyBlock onNext={handleNextAction("step2")} />}
            {current.step2 && <PropertyDetailBlock onNext={handleNextAction("step3")} />}
            {current.step3 && <SaleReason onNext={handleNextAction("step4")} />}
            {current.step4 && (
              <>
                <CustomerBlock />
              </>
            )}
          </Col>
          <Col size={rl2.part3}>
            <DisplayNone>*</DisplayNone>
          </Col>
          <Col size={rl2.part4} float={!current.step1 ? "right" : "left"}>
            {range !== "sm" && <StepProgressBar progress={current} backgroundColor={COLOR_THEME.extras?.secondary} />}
          </Col>
        </Row>
        {current.step4 && (
          <Row>
            <ValuationConfirm />
          </Row>
        )}
      </FormProvider>
      <Footer />
    </IndexPageWrapper>
  );
};

export default IndexPage;
